module.exports = __webpack_public_path__ + "assets/img/tx230_1.dda5daa1.jpg";